import { AnimatePresence, motion } from "motion/react";
import CalendarDatePicker, { last7Days } from "ui/components/comp-507";

import { Button } from "ui/components/button";
import ComboboxWrapper from "components/list/combobox-wrapper-with-api";
import { Label } from "ui/components/label";
import { fetchProjectsForTimesheetLog } from "@/modules/timesheet/logs/views/table/api";
import { formatDateForAPI } from "utils/utils";
import useTableFilters from "@/hooks/useTableFilters";
import { Switch } from "ui/components/switch";

// Function to fetch projects for filter

export default function TimesheetFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  clearFilters,
}) {
  const {
    localFilters,
    updateFilter,
    updateDateRangeFilter,
    updateComboboxFilter,
    applyFilters,
    handleSetLocalFilters,
    clearLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      project: undefined,
      date: {
        _gte: formatDateForAPI(last7Days.from),
        _lte: formatDateForAPI(last7Days.to),
      },
      unapproved_hours: {
        _nnull: undefined,
      },
      _unreviewed_hours: undefined,
    },
  });

  return (
    <div className="w-full p-4 space-y-4">
      <div>
        <Label className="mb-2 text-sm">Project </Label>
        <ComboboxWrapper
          filterKey="project"
          filters={localFilters}
          setFilters={setFilters}
          fetchFn={fetchProjectsForTimesheetLog}
          valueKey="id"
          className="w-full"
          labelKey={["name"]}
          placeholder="Select"
          searchPlaceholder="Search project..."
          dependsOn={isOpen}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              project: {
                _eq: selectedItem.value,
                __selectedItem: selectedItem,
              },
            });
          }}
        />
      </div>

      {/* Date Range Filter */}

      <div>
        <Label className="mb-2 text-sm">Date </Label>

        <CalendarDatePicker
          stack={true}
          date={{
            from: localFilters?.date?._gte,
            to: localFilters?.date?._lte,
          }}
          setDate={updateDateRangeFilter}
          className="w-full"
        />
      </div>

      {/* Unapproved Hours Slider */}
      <div className="flex items-center justify-between">
        <Label className="mb-4 text-sm">Unapproved Hours</Label>
        <Switch
          checked={localFilters?.unapproved_hours?._gt === 0 ? true : false}
          onCheckedChange={(checked) => {
            if (checked) {
              handleSetLocalFilters({ unapproved_hours: { _gt: 0 } });
            } else {
              handleSetLocalFilters({ unapproved_hours: undefined });
            }
          }}
        />
      </div>

      {/* Unreviewed Hours Switch */}
      <div className="flex items-center justify-between">
        <Label className="text-sm">Unreviewed Entries</Label>
        <Switch
          checked={localFilters?._unreviewed_hours?._eq}
          onCheckedChange={(checked) => {
            if (checked) {
              handleSetLocalFilters({
                approved_hours: { _null: true },
                unapproved_hours: { _null: true },
                _unreviewed_hours: { _eq: checked },
              });
            } else {
              handleSetLocalFilters({
                approved_hours: undefined,
                unapproved_hours: undefined,
                _unreviewed_hours: undefined,
              });
            }
          }}
        />
      </div>

      {/* Action Buttons */}

      <div className="flex place-self-end gap-4">
        <Button variant="outline" onClick={clearLocalFilters}>
          Clear
        </Button>

        <Button onClick={() => applyFilters()}>Apply</Button>
      </div>
    </div>
  );
}
